import { render, staticRenderFns } from "./pwa_article_delivery.vue?vue&type=template&id=3883df07&scoped=true&"
import script from "./pwa_article_delivery.vue?vue&type=script&lang=js&"
export * from "./pwa_article_delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3883df07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3883df07')) {
      api.createRecord('3883df07', component.options)
    } else {
      api.reload('3883df07', component.options)
    }
    module.hot.accept("./pwa_article_delivery.vue?vue&type=template&id=3883df07&scoped=true&", function () {
      api.rerender('3883df07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/texts/pwa_article_delivery.vue"
export default component.exports